import PropTypes from "prop-types"
import { convertToShortFormat } from "lib/functions"
import playIcon from "./play.svg"
import * as css from "./RecordedDemoButton.module.css"

function RecordedDemoButton({ date, title, onClick }) {
  return (
    <button className={css.button} onClick={onClick} type="button">
      <div className={css.wrapper}>
        <img className={css.icon} src={playIcon} alt="Play" />
      </div>
      <div className={css.content}>
        {date && (
          <div className={css.suptitle}>
            Recorded on {convertToShortFormat(date)}
          </div>
        )}
        <div className={css.title}>{title}</div>
      </div>
    </button>
  )
}

RecordedDemoButton.propTypes = {
  date: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
}

export default RecordedDemoButton
